import { render, staticRenderFns } from "./payment-detail.vue?vue&type=template&id=0acc0f91"
import script from "./payment-detail.vue?vue&type=script&lang=ts"
export * from "./payment-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports